module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/point03-2956439cc0b7ec8b86478281fc889765.png";